'use client';

import { lazy } from 'react';

export default lazy(() => import('@/components/ErrorBoundary'));
